import React from "react";
import { PageHeader } from "../components/PageHeader";
import { Banknote, Coins, Briefcase, Plane, Building2, ArrowUpRight, ShieldCheck, FileCheck } from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  {
    icon: <Banknote className="w-6 h-6" />,
    title: "Döviz Alım-Satım",
    description:
      "USD, EUR, GBP, CHF, JPY ve 20+ farklı para birimi için anlık piyasa kurlarıyla şeffaf alım-satım hizmeti.",
  },
  {
    icon: <Coins className="w-6 h-6" />,
    title: "Altın Alım-Satım",
    description:
      "Gram, çeyrek, yarım, tam ve cumhuriyet altını başta olmak üzere tüm kıymetli maden işlemleri.",
  },
  {
    icon: <ShieldCheck className="w-6 h-6" />,
    title: "B Grubu Yetkili Müessese",
    description:
      "Akaydın Döviz Ve Altın Ticareti Sınırlı Yetkili Müessese A.Ş. olarak mevzuata uygun, denetimli işlem güvencesi.",
  },
  {
    icon: <Briefcase className="w-6 h-6" />,
    title: "Kurumsal Hizmetler",
    description:
      "İhracatçı ve ithalatçılara özel kur takibi, toplu işlem ve avantajlı kurumsal kurlar.",
  },
  {
    icon: <Plane className="w-6 h-6" />,
    title: "Turist Hizmetleri",
    description:
      "Turistler için pratik, hızlı ve güvenilir döviz alım-satım hizmeti. Çoklu dil desteği.",
  },
  {
    icon: <FileCheck className="w-6 h-6" />,
    title: "Profesyonel Danışmanlık",
    description:
      "Kur ve altın piyasası konusunda uzman ekibimizden bilgi ve danışmanlık desteği.",
  },
];

export default function Hizmetler() {
  return (
    <>
      <PageHeader
        eyebrow="Ne Yapıyoruz?"
        title="Hizmetlerimiz"
        description="Akaydın Döviz olarak bireysel ve kurumsal müşterilerimize sunduğumuz finans hizmetlerinin tamamı."
      />
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {services.map((s, i) => (
              <div
                key={i}
                className="group p-8 rounded-2xl bg-white border border-slate-200 hover:border-slate-950 hover:shadow-xl hover:-translate-y-1 transition-all"
              >
                <div className="w-12 h-12 rounded-xl bg-slate-950 text-brand-gold flex items-center justify-center mb-5 group-hover:bg-brand-gold group-hover:text-slate-950 transition-colors">
                  {s.icon}
                </div>
                <h3 className="font-display text-xl font-bold text-slate-950 mb-2">{s.title}</h3>
                <p className="text-sm text-slate-600 leading-relaxed">{s.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-16 p-10 md:p-14 rounded-3xl bg-slate-950 text-white relative overflow-hidden">
            <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-brand-gold/20 blur-3xl" />
            <div className="relative grid md:grid-cols-[1fr_auto] gap-8 items-center">
              <div>
                <div className="text-[11px] uppercase tracking-[0.25em] text-brand-gold font-bold mb-3">
                  Bireysel & Kurumsal
                </div>
                <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight leading-tight mb-3">
                  Size özel çözüm için bize ulaşın.
                </h2>
                <p className="text-slate-300">Uzman ekibimiz işlemlerinize özel kur ve danışmanlık sunar.</p>
              </div>
              <Link
                to="/iletisim"
                className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-brand-gold text-slate-950 font-bold text-sm hover:bg-white transition-colors group whitespace-nowrap"
              >
                İletişime Geç
                <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
